module.exports = __webpack_public_path__ + "static/media/piper-dialog2-desktop-es.6e29b49e.svg";